<div fxLayout="column" fxLayoutGap="20px">
  <h2>Perfis do usuário: {{ identificacao }}</h2>

  <app-search-input #searchInput (search)="search($event)" placeholder=""></app-search-input>

  <div>
    <table mat-table #table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
        <td mat-cell *matCellDef="let usuario">{{ usuario.nome }}</td>
      </ng-container>
      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
        <td mat-cell *matCellDef="let usuario">{{ usuario.descricao }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="5">
          <app-table-no-data [searchValue]="searchInput.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator></app-default-paginator>
  </div>
</div>
